import { render } from "./ScrollToTop.vue?vue&type=template&id=4d77633f&scoped=true&ts=true"
import script from "./ScrollToTop.vue?vue&type=script&lang=ts"
export * from "./ScrollToTop.vue?vue&type=script&lang=ts"

import "./ScrollToTop.vue?vue&type=style&index=0&id=4d77633f&lang=scss&scoped=true"

import exportComponent from "E:\\web-developer\\vuejs-projects\\WPF-admins-egypt-WEB-Vue.ts\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d77633f"]])

export default __exports__